export default __webpack_public_path__ + "static/media/Zone-4-Master-Plan-Type-F.1182a611.png";